exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ndiv[data-v-44014aa9] {\n    text-align: left;\n    color: #192d36;\n}\n", ""]);

